import { ProductAttributeKey } from '../../@api/Sylius';
import { Link } from '../../Link/Link';
import { MarketingAction } from '../../MarketingAction/MarketingAction';
import { ProductPriceInterface } from '../../Price/Price';
import { ProductAttribute, ProductDimensionAttribute } from '../ProductAttribute/ProductAttribute';
import { ProductVariantColor } from '../ProductVariantColor/ProductVariantColor';

export interface ProductVariant {
    id: string;
    legacyId?: string;
    variantId: string;
    variantCode: string;
    productCode: string;
    name: string;
    relativeUrl: string;
    description: string;
    isNew: boolean;
    price: ProductPriceInterface;
    marketingAction?: MarketingAction;
    deliveryNotice?: string;
    attributes: ProductAttribute[];
    dimensionAttributes: ProductDimensionAttribute[];
    brand?: Link;
    colors: ProductVariantColor[];
    inStock: boolean;
    stockQuantity: number;
}

export const dimensionAttributeKeys = [ProductAttributeKey.deliveryMin, ProductAttributeKey.deliveryMax];
